export default __webpack_public_path__ + "static/media/home-restaurant-img-02.e8c6ece7.jpg";